<template>
    <div>
        <div class="footer_box">
            <div class="bottom_box">
                <div class="search_box">
                    <SearchInputSp/>
                </div>
                <div class="footer_sample_book" @click="$modal.show('sample_book_search_modal')"><img src="../assets/images/footer_sample_book.svg" alt="見本帳で検索"></div>
                <div class="footer_sukikamo_style">
                    <div class="footer_sukikamo" @click="$modal.show('room_search_modal')"><img src="../assets/images/footer_room.svg" alt="部屋別で検索"></div>
                    <div id="kamo_fukidashi"><img src="../assets/images/footer_fukidashi_sp.svg" alt="吹き出し"></div>
                </div>

                <div class="footer_floor" @click="$modal.show('floor_search_modal')"><img src="../assets/images/footer_floor.svg" alt="床色で検索"></div>
                <div class="footer_style" @click="$modal.show('style_search_modal')"><img src="../assets/images/footer_style.svg" alt="スタイルで検索"></div>

            </div>
        </div>

        <modal name="sample_book_search_modal" width="80%" height="auto">
            <div>
                <SearchCheckBox
                        caption="見本帳で検索"
                        :items="sample_book_tag_names"
                        :checked_items="checked_sample_book_tag"
                        @change="setSelectedSampleBook"
                        @close="$modal.hide('sample_book_search_modal')"
                />
            </div>
        </modal>
        <modal name="room_search_modal" width="80%" height="auto">
            <div>
                <SearchCheckBox
                        caption="部屋別で検索"
                        :items="room_tag_names"
                        :checked_items="checked_room_tag"
                        @change="setSelectedRoom"
                        @close="$modal.hide('room_search_modal')"
                />
            </div>
        </modal>
        <modal name="floor_search_modal" width="80%" height="auto">
            <div>
                <SearchCheckBox
                        caption="床色で検索"
                        :items="floor_tag_names"
                        :checked_items="checked_floor_tag"
                        @change="setSelectedFloor"
                        @close="$modal.hide('floor_search_modal')"
                />
            </div>
        </modal>
        <modal name="style_search_modal" width="80%" height="auto">
            <div>
                <SearchCheckBox
                        caption="スタイルで検索"
                        :items="style_tag_names"
                        :checked_items="checked_style_tag"
                        @change="setSelectedStyle"
                        @close="$modal.hide('style_search_modal')"
                />
            </div>
        </modal>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import SearchCheckBox from '../components/SearchCheckBox'
    import Ajax from '../assets/js/Ajax'
    import Util from '../assets/js/Util'
    import SearchInputSp from '../components/SearchInputSp'

    export default {
        name: "SearchFooter",
        components: { SearchCheckBox, SearchInputSp },
        data: () => ({
            style_tags: [],
            room_tags: [],
            floor_tags: [],
            sample_book_tags: [],
        }),
        computed: {
            ...mapState('search', ['search_conditions', 'search_text']),
            style_tag_names: _this => _this.style_tags.map(tag => tag.name_ja),
            room_tag_names: _this => _this.room_tags.map(tag => tag.name_ja),
            floor_tag_names: _this => _this.floor_tags.map(tag => tag.name_ja),
            sample_book_tag_names: _this => _this.sample_book_tags.map(tag => tag.name_ja),
            checked_style_tag: _this => _this.search_conditions.filter(tag => tag.category === 'style').map(tag => tag.name_ja),
            checked_room_tag: _this => _this.search_conditions.filter(tag => tag.category === 'room').map(tag => tag.name_ja),
            checked_floor_tag: _this => _this.search_conditions.filter(tag => tag.category === 'floor').map(tag => tag.name_ja),
            checked_sample_book_tag: _this => _this.search_conditions.filter(tag => tag.category === 'sample_book').map(tag => tag.name_ja),
        },
        async created() {
            const {style, room, floor, sample_book} = await Ajax.getSearchTags();
            this.style_tags = style;
            this.room_tags = room;
            this.floor_tags = floor;
            this.sample_book_tags = sample_book;
        },
        methods: {
            ...mapMutations('search', ["setSearchConditions"]),
            setSelectedStyle(tags) {
                const current_tags_without_style_tag = this.search_conditions.filter(t => t.category !== 'style').map(t => t.name_ja);
                const tags_ja = [...current_tags_without_style_tag, ...tags];
                this.emitSearchConditions(tags_ja);
            },
            setSelectedRoom(tags) {
                const current_tags_without_room_tag = this.search_conditions.filter(t => t.category !== 'room').map(t => t.name_ja);
                const tags_ja = [...current_tags_without_room_tag, ...tags];
                this.emitSearchConditions(tags_ja);
            },
            setSelectedFloor(tags) {
                const current_tags_without_floor_tag = this.search_conditions.filter(t => t.category !== 'floor').map(t => t.name_ja);
                const tags_ja = [...current_tags_without_floor_tag, ...tags];
                this.emitSearchConditions(tags_ja);
            },
            setSelectedSampleBook(tags) {
                const current_tags_without_sample_book_tag = this.search_conditions.filter(t => t.category !== 'sample_book').map(t => t.name_ja);
                const tags_ja = [...current_tags_without_sample_book_tag, ...tags];
                this.emitSearchConditions(tags_ja);
            },
            async emitSearchConditions(tags_ja) {
                const tag_data = await Ajax.getTagData();
                const tags = tags_ja
                    .map(tag => tag_data.find(t => t.name_ja === tag))
                    .filter(d => d);
                this.setSearchConditions(tags);
                const query_param = Util.generateQueryParam('tags[]', tags_ja, this.search_text);
                await this.$router.push('/?' + query_param, () => {});
            },
        },
        mounted(){
            // 指を離したら
            var kamo_fukidashi = document.querySelector("#kamo_fukidashi");
            window.addEventListener("touchend", function (event) {
                var fn = function() {
                    // console.log("指離し");
                    kamo_fukidashi.style.display = "block" ;
                };
                var tm = 4000;
                setTimeout(fn,tm);
            });
            //タッチしたら
            window.addEventListener("touchstart", function (event) {
                // console.log("タッチ中");
                kamo_fukidashi.style.display = "none" ;
            });
        }
    };


</script>

<style scoped lang="scss">
    .footer_box {
        width: 100%;
        height: 92px;
        padding: 10px 10px 7px 0;
        box-sizing: border-box;
        background-color: white;
        display: flex;
        justify-content: flex-end;
        .bottom_box {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            align-items: flex-end;
            width: 300px;
            .footer_style {
                img {
                    height: 23px;
                }
            }
            .search_box {
                position: absolute;
                top: 7px;
                right: 143px;
            }
        }

        .footer_help_btn_sp img {
            height: 45px;
        }
        .footer_sample_book {
            margin: 0 5px -2px auto;
            img {
                height: 23px;
            }
        }
        .footer_floor {
            margin: 0 5px 0 0;
            img {
                height: 23px;
            }
        }
        .footer_sukikamo_style {
            position: relative;
            .footer_sukikamo {
                margin-top: -11px;
                margin-bottom: -2px;
                img {
                    height: 57.5px;
                }
            }
            #kamo_fukidashi {
                display: none;
                position: absolute;
                top: -129px;
                left: -21px;
            }
        }
    }
</style>
